import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseElement } from '../../base-element';

@Component({
  selector: 'single-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: [ './switcher.component.scss' ],
  encapsulation: ViewEncapsulation.None,
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SingleSwitcherComponent),
    multi: true
  } ]
})
export class SingleSwitcherComponent extends BaseElement<string> {

  @Input() model: any = {};
  @Input() prop: any = '';
  @Input() onValue: any = true;
  @Input() onValueLabel: string = 'Active';
  @Input() offValue: any = false;
  @Input() offValueLabel: string = 'Inactive';
  @Input() isChangingState?: boolean = true

  onChange(value): void {
    this.model[this.prop] = value;
    if (this.change) {
      this.change.emit(this.model);
    }
  }

  setValue(value: string) {
    if (this.isChangingState) this.onChange(value);
  }
}
